// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-color{color:#000!important}.isi-content{font-size:20px}.text{color:#d91046}.link-color{color:#1e1e1e!important}.boxed-warning{border:4px solid #4e5054;padding:10px}.warning-box{padding:14px}.inline{display:inline}li{margin-bottom:10px}h2{font-size:24px}", ""]);
// Exports
exports.locals = {
	"primaryColor": "#00a0df",
	"secondaryColor": "#003479",
	"accentColor": "#d91046",
	"brandGreyColor": "#4e5054",
	"mainBackgroundColor": "#f8f7f7",
	"headerBackgroundColor": "#f8f7f7"
};
module.exports = exports;
